import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface EventMasterState {
    data: [] | null | any;
    currentPage: number | null;
    totalRecords: number | null;
    totalPages: number | null;
    allEventMaster: [] | null | any;
}
const initialState: EventMasterState = {
    data: null,
    totalRecords: null,
    totalPages: null,
    currentPage: null,
    allEventMaster: null,
};
export const eventMasterSlice = createSlice({
    name: 'EventMaster',
    initialState,
    reducers: {
        setAllEventMaster: (state, action) => {
            state.allEventMaster = action.payload.data;
        },
        setEventMaster: (state, action) => {
            state.data = action.payload.data.data ? action.payload.data.data : action.payload.data;
            state.totalRecords = action.payload.data.totalRecords;
            state.totalPages = action.payload.data.totalPages;
            state.currentPage = action.payload.data.currentPage;
        },
        reset: (state) => {
            Object.assign(state, initialState);
        },
    },
});
export const { setAllEventMaster, setEventMaster, reset } = eventMasterSlice.actions;
export const allEventMasterDetails = (state: RootState) => state.eventMaster.allEventMaster;
export const getAllEventMasterDetails = (state: RootState) => state.eventMaster.data;
export const getEventMasterTotalRecords = (state: RootState) => state.eventMaster.totalRecords;
export default eventMasterSlice.reducer;
